<form [formGroup]="technicalAssistanceForm" class="technical-assistance-form">
  <div class="form-section">
    <div class="form-grid">
      <div class="form-group full-width">
        <label for="industry" class="required"
          >What Industry is your business in?</label
        >
        <select id="industry" formControlName="industry">
          <option value="">Select an industry</option>
          @for (industry of industryOptions; track industry.value) {
            <option [value]="industry.value">{{ industry.label }}</option>
          }
        </select>
        @if (
          technicalAssistanceForm.get("industry")?.touched &&
          technicalAssistanceForm.get("industry")?.invalid
        ) {
          <span class="error-message">Industry selection is required</span>
        }
      </div>
    </div>

    <div class="checkbox-section">
      <fieldset>
        <legend class="checkbox-legend">
          Do you need help with a certain aspect of your business? (Select any)
        </legend>
        <div class="checkbox-grid" formGroupName="supportAreas">
          @for (area of supportAreas; track area) {
            <div class="checkbox-item">
              <input
                [id]="'support_' + sanitizeKey(area)"
                type="checkbox"
                [formControlName]="sanitizeKey(area)"
              />
              <label [for]="'support_' + sanitizeKey(area)">{{ area }}</label>
            </div>
          }
        </div>
      </fieldset>
    </div>

    @if (isBusinessSuccessionPlanningSelected()) {
      <div class="succession-planning-section">
        <h4 class="subsection-title">Business Succession Planning Details</h4>

        <div class="form-grid">
          <div class="form-group full-width">
            <span class="group-label required"
              >Are you interested in selling your business?</span
            >
            <div class="radio-options">
              <div class="radio-item">
                <input
                  id="sellingYes"
                  type="radio"
                  formControlName="interestedInSellingBusiness"
                  value="yes"
                />
                <label for="sellingYes">Yes</label>
              </div>
              <div class="radio-item">
                <input
                  id="sellingNo"
                  type="radio"
                  formControlName="interestedInSellingBusiness"
                  value="no"
                />
                <label for="sellingNo">No</label>
              </div>
              <div class="radio-item">
                <input
                  id="sellingPlan"
                  type="radio"
                  formControlName="interestedInSellingBusiness"
                  value="make_plan"
                />
                <label for="sellingPlan">I want to make a plan</label>
              </div>
            </div>
            @if (
              technicalAssistanceForm.get("interestedInSellingBusiness")
                ?.touched &&
              technicalAssistanceForm.get("interestedInSellingBusiness")
                ?.invalid
            ) {
              <span class="error-message">This field is required</span>
            }
          </div>

          <div class="form-group full-width">
            <span class="group-label required"
              >Are you interested in Strategies to engage, retain, and reward
              employees?</span
            >
            <div class="radio-options">
              <div class="radio-item">
                <input
                  id="employeeYes"
                  type="radio"
                  formControlName="interestedInEmployeeStrategies"
                  value="yes"
                />
                <label for="employeeYes">Yes</label>
              </div>
              <div class="radio-item">
                <input
                  id="employeeNo"
                  type="radio"
                  formControlName="interestedInEmployeeStrategies"
                  value="no"
                />
                <label for="employeeNo">No</label>
              </div>
              <div class="radio-item">
                <input
                  id="employeeLearn"
                  type="radio"
                  formControlName="interestedInEmployeeStrategies"
                  value="learn_more"
                />
                <label for="employeeLearn">I want to learn more</label>
              </div>
            </div>
            @if (
              technicalAssistanceForm.get("interestedInEmployeeStrategies")
                ?.touched &&
              technicalAssistanceForm.get("interestedInEmployeeStrategies")
                ?.invalid
            ) {
              <span class="error-message">This field is required</span>
            }
          </div>

          <div class="form-group full-width">
            <span class="group-label required"
              >Are you interested in Succession planning and ensuring future
              ownership of your company?</span
            >
            <div class="radio-options">
              <div class="radio-item">
                <input
                  id="successionYes"
                  type="radio"
                  formControlName="interestedInSuccessionPlanning"
                  [value]="true"
                />
                <label for="successionYes">Yes</label>
              </div>
              <div class="radio-item">
                <input
                  id="successionNo"
                  type="radio"
                  formControlName="interestedInSuccessionPlanning"
                  [value]="false"
                />
                <label for="successionNo">No</label>
              </div>
            </div>
            @if (
              technicalAssistanceForm.get("interestedInSuccessionPlanning")
                ?.touched &&
              technicalAssistanceForm.get("interestedInSuccessionPlanning")
                ?.invalid
            ) {
              <span class="error-message">This field is required</span>
            }
          </div>
        </div>
      </div>
    }

    <div class="form-grid">
      <div class="form-group">
        <span class="group-label"
          >Have you worked with a support organization before?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="workedYes"
              type="radio"
              formControlName="workedWithSupportOrg"
              [value]="true"
            />
            <label for="workedYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="workedNo"
              type="radio"
              formControlName="workedWithSupportOrg"
              [value]="false"
            />
            <label for="workedNo">No</label>
          </div>
        </div>
        @if (
          technicalAssistanceForm.get("workedWithSupportOrg")?.touched &&
          technicalAssistanceForm.get("workedWithSupportOrg")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      <div class="form-group">
        <span class="group-label"
          >Would you be willing to pay for Small Business Technical
          Assistance?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="payYes"
              type="radio"
              formControlName="willingToPay"
              value="yes"
            />
            <label for="payYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="payNo"
              type="radio"
              formControlName="willingToPay"
              value="not_at_this_time"
            />
            <label for="payNo">Not at this time</label>
          </div>
        </div>
        @if (
          technicalAssistanceForm.get("willingToPay")?.touched &&
          technicalAssistanceForm.get("willingToPay")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>
    </div>
  </div>
</form>
